export default {
      id: "tune-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#tune-usage",
      toString: function () {
        return this.url;
      }
    }